import { render } from "./Invoice.vue?vue&type=template&id=50b0a16e&scoped=true"
import script from "./Invoice.vue?vue&type=script&lang=js"
export * from "./Invoice.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-50b0a16e"

export default script